import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { assignUserRole, getUserRole } from "./redux/action";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import GetTreeViewData from "./GetTreeViewData";
import { Button, Card, useTheme } from "@mui/material";
import { toast } from "react-toastify";
import MyCard from "../../components/MyCard";
import { tokens } from "../../theme";
import GlobalLoader from "../../components/GlobalLoader";
import { dependentRoles, setTitle } from "../../utils/custom";
import { InternalPageHeader } from "../../components/Header";

export default function UserRole() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [checked, setChecked] = useState([""]);
  const [userInfo, setUserInfo] = useState([]);
  const [expanded, setExpanded] = useState(["all"]);
  const [nodes, setNodes] = useState([]);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { isLoading } = useSelector((state) => state.users, shallowEqual);

  useEffect(() => {
    setTitle("Assign Role | DoorVenza");
    if (id) {
      dispatch(getUserRole(id)).then((data) => {
        if (data.type === "USERS_ROLE_SUCCESS") {
          setChecked(data?.payload?.data.userRoles);
          setUserInfo(data?.payload?.data);
          const treeOfRoles = GetTreeViewData(data?.payload?.data.totalRoles);
          setNodes([treeOfRoles]);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const assignRole = () => {
    dispatch(assignUserRole({ userId: id, userRole: [...new Set(checked)] })).then((data) => {
      if (data.type === "USERS_ROLE_ASSIGN_SUCCESS") {
        toast.success(data.payload.message);
        // navigate("/users");
      }
    });
  };

  return (
    <Box sx={{ mx: { xs: "15px", sm: "20px" } }}>
      <Grid container spacing={1} my="20px">
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
          <InternalPageHeader to="/users" title="Users Role" />
        </Grid>
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12} sx={{ textAlign: "right" }}>
          {isLoading ? null : (
            <Button
              variant="contained"
              onClick={assignRole}
              sx={[
                {
                  "&:hover": {
                    bgcolor: colors.themeSecondaryBlueColor[100],
                    color: colors.white[100]
                  }
                },
                { bgcolor: colors.themeDarkGrey[100] }
              ]}
            >
              Assign Role
            </Button>
          )}
        </Grid>
      </Grid>
      {isLoading ? (
        <Card sx={{ maxHeight: 500, minHeight: 500, display: "flex", alignItems: "center" }}>
          <GlobalLoader />
        </Card>
      ) : (
        <MyCard>
          <Box display="flex" mb={1} p={1}>
            <Typography color={colors.greenAccent[500]} variant="h4" fontWeight="600">
              Username:
            </Typography>
            <Typography color={colors.blueAccent[100]} variant="h4" fontWeight="600" sx={{ pl: 1 }}>
              {userInfo?.firstName} {userInfo?.lastName}
            </Typography>
          </Box>
          <Box sx={{ overflowY: "auto", maxHeight: 500, minHeight: 300 }}>
            <CheckboxTree
              nodes={nodes}
              checked={checked}
              expanded={expanded}
              onCheck={async (c) => {
                const singleChecked = c.filter((obj) => checked.indexOf(obj) === -1);
                const selectedRole = singleChecked[0];

                if (selectedRole) {
                  const dependencies = dependentRoles[selectedRole];

                  if (dependencies) {
                    const updatedChecked = [...c, ...(Array.isArray(dependencies) ? dependencies : [dependencies])];
                    setChecked(updatedChecked);
                  } else {
                    setChecked(c);
                  }
                } else {
                  setChecked(c);
                }
              }}
              onExpand={(expanded) => setExpanded(expanded)}
              showNodeIcon={false}
              icons={{
                check: <CheckBoxOutlinedIcon />,
                uncheck: <CheckBoxOutlineBlankOutlinedIcon />,
                halfCheck: <CheckBoxOutlinedIcon />,
                expandClose: <KeyboardArrowDownIcon />,
                expandOpen: <KeyboardArrowUpIcon />,
                expandAll: <KeyboardArrowUpIcon />
              }}
            />
          </Box>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap="10px"
            width="100%"
            bgcolor="#fff"
            position="sticky"
            bottom="0"
          >
            <Box>
              <NavLink to="/users">
                <Button variant="outlined">Cancel</Button>
              </NavLink>
            </Box>
            <Box>
              {isLoading ? null : (
                <Button
                  variant="contained"
                  onClick={assignRole}
                  sx={[
                    {
                      "&:hover": {
                        bgcolor: colors.themeSecondaryBlueColor[100],
                        color: colors.white[100]
                      }
                    },
                    { bgcolor: colors.themeDarkGrey[100] }
                  ]}
                >
                  Assign Role
                </Button>
              )}
            </Box>
          </Box>
        </MyCard>
      )}
    </Box>
  );
}
